export default __webpack_public_path__ + "static/techforgood-SW-cb3a1cb90a4adf56642bb48dc1074dcf.png";